import { BaseRemoteService } from "@ofqual/portal-core/core/dataAccess";
import { Model, Opts } from "@ofqual/portal-core/core/types";

export class RefDataService extends BaseRemoteService {
  private resource: string;

  constructor(baseUrl: string, resource: string) {
    super(baseUrl);
    this.resource = resource;
  }

  public async getAll(opts: Opts): Promise<Model[]> {
    const url = `${this.apiRoot}/${this.resource}`;
    const data = await super.getRequest<Model[]>(url, opts);
    return data
      .filter((x) => x.active)
      .sort((a, b) => {
        const sortOrderOrder = !!a.sortOrder && !!b.sortOrder
          ? (a.sortOrder - b.sortOrder)
          : 0;
        return sortOrderOrder === 0
          ? a.value.localeCompare(b.value, 'en')
          : sortOrderOrder;
      })
      .map(x => ({ id: x.id, label: x.value }));
  }
  public async get(id: string, opts: Opts): Promise<Model> {
    const url = `${this.apiRoot}/${this.resource}/${id}`;
    const item = await super.getRequest<Model>(url, opts);
    return {
      ...item,
      label: item.value
    };
  }
}

export const refDataEndpoints = {
  customerType: "customertypeoptions",
  focusOfEnquiry: "focusofenquiryoptions",
  category: "foicategoryoptions",
  themeOfEnquiry: "themeofenquiryoptions",
  foiType: "foitypeoptions",
  ragRating: "ragratingoptions",
  source: "foisourceoptions",
  gqVtq: "gqvtqoptions",
  directorate: "directorates",
  learnerType: "pelearnertypeoptions",
  caseTypeSla: "pecasetypeslaoptions",
  contactMethod: "pecontactmethodoptions",
  exceptionalCircumstance: "peexceptionalcircumstanceoptions",
  status: "pestatusoptions",
  qualTypes: "qualificationtypes",
  categoryPe: "pecategoryoptions",
  foiExemptions: "foiexemtionoptions"
};
